
<form [formGroup]="scadenzaForm">

	<div class="row">
		<div class="form-group col-md-3">
			<label for="data" class="col-form-label">Data</label>
			<p-calendar formControlName="data" class="inputScadenzeForm" dateFormat="dd/mm/yy"></p-calendar>
			<small *ngIf="!scadenzaForm.get('data').valid && scadenzaForm.get('data').touched" class="color-red">
				Inserisci una data
			</small>
		</div>

		<div class="form-group col-md-9">
			<label for="descrizione" class="col-form-label">Descrizione</label>
			<textarea formControlName="descrizione" type="text" class="form-control inputScadenzeForm" rows="1" cols="30" pInputTextarea [autoResize]="true"></textarea>
			<small *ngIf="!scadenzaForm.get('descrizione').valid && scadenzaForm.get('descrizione').touched" class="color-red">
				Inserisci una descrizione
			</small>
		</div>



		<div class="form-group col-md-12">
		  <label for="alertAt" class="col-form-label">Alert</label>
		  <div class="alert-display">
			<div *ngFor="let option of options">
				<p-checkbox formControlName="alertAt" [value]="option.days" [label]="option.label" [(ngModel)]="selectedAlert" ></p-checkbox>
			</div>
		  </div>
			<small *ngIf="!scadenzaForm.get('alertAt').valid && scadenzaForm.get('alertAt').touched" class="color-red">
				Seleziona una scadenza
			</small>
		</div>

		<div class="form-group col-md-2">
			<label for="evaso" class="col-form-label">Evaso</label>
			<p-inputSwitch formControlName="evaso" styleClass="mt-1"></p-inputSwitch>
		</div>
		<div class="form-group col-md-10">
			<label for="emails" class="col-form-label">Email</label>
			<div class="col-12 email-display">
				<p-chips formControlName="emails" [separator]="separatorExp"></p-chips>
			</div>
			<small *ngIf="!scadenzaForm.get('emails').valid && scadenzaForm.get('emails').touched" class="color-red">
				Inserisci almeno una mail
			</small>
		</div>
	</div>

	<div class="footer mt-4" >
		<div *ngIf="isInEdit && (!permesso || permesso === TipoPermesso.ReadWrite || permesso === TipoPermesso.ReadWriteDelete || user.roles === RuoloPipe.transform(Ruolo.SuperAdministrator))" class="button-display">

			<button *ngIf="!scadenzaForm.enabled" pButton label="MODIFICA" [disabled]="scadenzaForm.invalid" icon="pi pi-pencil" class="mr-2"
				(click)="scadenzaForm.enable()"></button>
			<p-toast></p-toast>
			<button *ngIf="scadenzaForm.enabled" pButton pRipple label="SALVA" [disabled]="scadenzaForm.invalid" icon="pi pi-check" class="mr-2"
				(click)="save()"></button>
			<button pButton label="ANNULLA" (click)="close(false)"></button>
		</div>

		<div *ngIf="!isInEdit" class="button-display">
			<p-toast></p-toast>
      		<button pButton label="AGGIUNGI" icon="pi pi-plus" class="mr-2" [disabled]="scadenzaForm.invalid" (click)="add()"></button>
      		<button pButton label="ANNULLA" (click)="close(false)"></button>
		</div>
	</div>

</form>





